// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3uboL","buttons":"Footer_buttons__82eFk"};